import useIsUserPowerBuyer from 'Utilities/hooks/useIsUserPowerBuyer';

export const useIsSellerCommunicationsAllowed = () => {
	const isUserPowerBuyer = useIsUserPowerBuyer();
	return isUserPowerBuyer;
};
